<div class="login-page">

  <div class="login-card">

    <div class="login-box">

      <img class="logo" src="assets/img/emdr logo monochrome white.svg" alt="EMDR therapy logo"/>


      <form class="form-body" [formGroup]="resetForm" (ngSubmit)="reset()" autocomplete="new-password">

        <div class="upper-login">
          <p style="color:white">Please enter your Email Address:</p>
          <div class ="inp">
            <input type="text" name="email" formControlName="email" placeholder="email@email.com" id="username" required>
          </div>  
        </div>

        <div class="lower-login">

          <div class="success" *ngIf="successMsg">{{successMsg}}</div>
          <div class="login-error" *ngIf="resetError">{{resetError}}</div>

            <button id="Connect" mat-raised-button color="darkGreen" type="submit" >Continue</button>
        </div>
      </form>
    </div>  

      <div class="emdr">
        @2021EMDRremote
      </div>

  </div>

</div>